import type { Theme } from '@mui/material/styles';

/**
 * Sync MUI theme palette to CSS custom properties on :root.
 * Tailwind utilities reference these via var(--color-*).
 */
export function syncCssVariables(theme: Theme): void {
  const root = document.documentElement;
  const p = theme.palette;

  root.style.setProperty('--color-primary', p.primary.main);
  root.style.setProperty('--color-secondary', p.secondary.main);
  root.style.setProperty('--color-background', p.background.default);
  root.style.setProperty('--color-surface', p.background.paper);
  root.style.setProperty('--color-text-primary', p.text.primary);
  root.style.setProperty('--color-text-secondary', p.text.secondary);
  root.style.setProperty('--color-success', p.success.main);
  root.style.setProperty('--color-warning', p.warning.main);
  root.style.setProperty('--color-error', p.error.main);
  root.style.setProperty('--color-info', p.info.main);
  root.style.setProperty('--color-neutral', p.grey[500]);
}
